import { config } from "@onflow/fcl"

config()
  .put("accessNode.api", process.env.REACT_APP_ACCESS_NODE) // Configure FCL's Access Node
  .put("env", process.env.REACT_APP_NETWORK)
  .put("discovery.wallet", process.env.REACT_APP_WALLET_DISCOVERY)
  .put("app.detail.title", ".find")
  .put("app.detail.icon", "https://find.xyz/find.png")
  .put("discovery.authn.include", [process.env.REACT_APP_DAPPER_WALLET_ADDRESS]) // Service account address

  //.put("sdk.transport", grpcSend)
  .put("decoder.Enum", (val) => {
    const result = {
      type: val.id
    };

    for (let i = 0; i < val.fields.length; i++) {
      const field = val.fields[i];
      result[field.name] = field.value;
    }

    return result;
  });

